import React from "react";
import "./services.scss"

const Services = React.forwardRef((props, ref) => {

    const elements = [
 {img:"/services-images/service-website.jpg",heading:"Website Design & Development",pointOne:"Responsive Website Design",pointTwo:"Front-end & Back-end Development", pointThree:"CMS Solutions (WordPress, Wix, etc.)",pointFour:"Maintenance & Support"},
 {img:"/services-images/service-mobile.jpg",heading:"Mobile App Development",pointOne:"Android App Development",pointTwo:"Cross-Platform Solutions (React Native)", pointThree:"App Testing and Deployment"},
 {img:"/services-images/service-solution.jpg",heading:"Custom Solutions",pointOne:"Manual to Automate Processes as per client needs",pointTwo:"Integration with Third-Party APIs", pointThree:"Custom Web Solutions"},
 {img:"/services-images/service-sac-dashboard.jpg",heading:"SAC Reports",pointOne:"Dashboard Design & Development",pointTwo:"Data Visualization", pointThree:"KPI Tracking and Metrics"},
 {img:"/services-images/service-ecommerce.jpg",heading:"E-Commerce Solutions",pointOne:"Custom E-Commerce Website Development",pointTwo:"Custom Online Stores", pointThree:"SEO and Performance Optimization"}
    ]
    return (
        <div ref={ref} className="services-container">
            <span className="services-container__heading">Our Services</span>
            <div className="services-container__inside-container">
                {elements?.map((elements,index)=>(
                    <div className="services-sub-container">
                        <div className="services-sub-container__div">
                            <img alt="service" className="services-sub-container__div__img" src={elements.img}></img>
                        </div>
                        <div className="services-sub-container__details">
                            <span className="services-sub-container__details__heading">{elements.heading}</span>
                            <span>🎯{elements.pointOne}</span>
                            <span>🎯{elements.pointTwo}</span>
                            <span>🎯{elements.pointThree}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
});

export default Services;